import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import { dashboardQueryOptions } from './dashboard-query-options';

export interface StudentEnrollmentData {
  _id: string;
  totalClassesEnrolled: number;
  studentName: string;
  classNames: Array<string>;
}

export interface Top10EnrolledStudentsParams {
  sessionId: string;
}

export const getTop10EnrolledStudentsAPI = async (
  params: Top10EnrolledStudentsParams,
) => {
  const response = await baseAPI.get<Array<StudentEnrollmentData>>(
    '/dashboard/metrics/active-students/top-10-enrolled',
    {
      params,
    },
  );
  return response.data;
};

export const useGetTop10EnrolledStudents = (
  params: Top10EnrolledStudentsParams,
) => {
  return useQuery({
    ...dashboardQueryOptions,
    queryKey: [KEYS.TOP_10_ENROLLED_STUDENTS, params.sessionId],
    queryFn: () => getTop10EnrolledStudentsAPI(params),
    enabled: !!params.sessionId,
  });
};
